import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";
import { format, parse } from 'date-fns'

const phoneAdapter = createEntityAdapter({
    selectId: (phone) => phone.phoneId,
    sortComparer: (a, b) => b.phoneId - a.phoneId
})

const phoneSummaryAdapter = createEntityAdapter({
    selectId: (phoneSummary) => phoneSummary.id
})

const initialState = phoneAdapter.getInitialState()
const phoneSummaryInitialState = phoneSummaryAdapter.getInitialState()

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllPhones: builder.query({
            query: userId => `/Phone`,
            transformResponse: responseData => {
                return phoneAdapter.setAll(initialState, responseData)
            },
            providesTags: (result, error, arg) => [
                { type: 'Phone', id: "LIST" },
                ...result.ids.map(id => ({ type: 'Phone', id }))
            ]
        }),
        getPhonesByUserId: builder.query({
            query: userId => `/Phone/${userId}`,
            transformResponse: responseData => {
                const loadedPhones = responseData.map(phone => {
                    if (phone?.callDate) {phone.callDate = format(parse(phone.callDate, "M/d/yyyy", new Date()), "d MMMM yyyy")};
                    return phone;
                });
                return phoneAdapter.setAll(initialState, loadedPhones)
            },
            providesTags: (result, error, arg) => [
                { type: 'Phone', id: "LIST" },
                ...result.ids.map(id => ({ type: 'Phone', id }))
            ]
        }),
        getPhoneSummeryByUserId: builder.query({
            query: userId => `/phone/phone_summary/${userId}`,
            transformResponse: responseData => {
                return phoneSummaryAdapter.addOne(phoneSummaryInitialState, responseData)
            },
            providesTags: (result, error, arg) => [
                { type: 'PhoneSummary', id: "DEFAULT_ID" },
            ]
        }),
    })
})

export const {
    useGetAllPhonesQuery,
    useGetPhonesByUserIdQuery,
    useGetPhoneSummeryByUserIdQuery
} = extendedApiSlice